import * as React from 'react';
import { ChildMutateProps, graphql } from 'react-apollo';

import { FormsLocale } from '../../../components/ContactPage/Forms/forms.locale';
import {
  default as SupportFormComponent,
  FormData,
} from '../../../components/ContactPage/Forms/SupportForm';
import contactSupportMutation from './contactSupportMutation.gql';
import { Mutation, SupportContactInput } from '../../../GraphQL';
import { formErrorHandler } from '../../Validator/formErrorHandler';

interface OwnProps {
  locale: FormsLocale;
}

interface ContactSupportVariables {
  contact: SupportContactInput;
  message: string;
}

interface SupportFormProps extends ChildMutateProps<OwnProps, Mutation, ContactSupportVariables> {}

const SupportForm: React.SFC<SupportFormProps> = ({ locale, mutate }) => {
  const handleFormSubmit = (values: FormData) =>
    mutate({
      variables: values,
    })
      .then(
        ({ data }) =>
          data.contactSupport.successful
            ? Promise.resolve()
            : Promise.reject(data.contactSupport.validationErrors),
      )
      .catch(error => formErrorHandler(error));

  return <SupportFormComponent locale={locale} onSubmit={handleFormSubmit} />;
};

export default graphql<OwnProps, Mutation, ContactSupportVariables, SupportFormProps>(
  contactSupportMutation,
)(SupportForm);



// WEBPACK FOOTER //
// /www/client/src/containers/ContactPage/SupportForm/SupportForm.tsx